/* eslint-disable no-shadow */
import SentenceStudyAssemblyBase from 'es6/controllers/apps/quizzes/sentence-study-assembly-base';

export class SentenceStudyTranslationAssembly extends SentenceStudyAssemblyBase {
  constructor(...args) {
    super(...args);
    this._mode = 'reading';
    this._setQuizType('SentenceStudyTranslationAssembly');

    // Give the first word as a hint and remove the word from the list of options.
    const wordSlot = this._wordSlots.find(wordSlot => !wordSlot.isFilled());
    const wordChoice = this._wordChoices.find(wordChoice => wordChoice.value === wordSlot.expected);
    this._wordChoices.splice(this._wordChoices.indexOf(wordChoice), 1);
    wordSlot.insert(wordChoice, true);
  }
}

export default SentenceStudyTranslationAssembly;
